export default {
	keys: {
		kulcsszo: 'keyWord',
		szobak: 'rooms',
		furdoszobak: 'bathrooms',
		allapot: 'conditionOfProperty',
		epitesimod: 'buildingStructure',
		futes: 'heating',
		kilatas: 'view',
		komfort: 'comfortLevel',
		lepcsohaz: 'staircaseType',
		tajolas: 'livingRoomOrientation',
		parkolas: 'parkingOption',
		ar: 'price',
		meret: 'area',
		emelet: 'floorsInBuilding',
		rendezes: 'order'
	},
	values: {
		saleType: {
			forSell: 'elado',
			forRent: 'kiado'
		},
		propertyType: {
			flat: 'lakas',
			house: 'haz',
			flatPlusHouse: 'lakas&haz',
			parcel: 'telek',
			garage: 'garazs',
			projectEstate: 'projektingatlan',
			office: 'iroda',
			shop: 'uzlethelyiseg',
			tourism: 'vendeglatas',
			industrial: 'ipari',
			agricultural: 'mezogazdasagi',
			parcelForInnovation: 'fejlesztesi-telek',
			publicInstitution: 'kozintezmeny-ingatlanja'
		},
		order: {
			'datum-szerint-csokkeno': 'createDateTimeDesc',
			'datum-szerint-novekvo': 'createDateTimeAsc',
			'ar-szerint-novekvo': 'priceHufAsc',
			'ar-szerint-csokkeno': 'priceHufDesc'
		},
		buildingStructure: {
			fa: 'wood',
			tegla: 'brick',
			panel: 'panel',
			'konnyu-szerkezet': 'lightStructure',
			egyeb: 'otherBuildingMaterial'
		},
		heating: {
			gaz: 'gas',
			elektromos: 'electric',
			tavfutes: 'remoteHeating',
			egyeb: 'otherHeating',
			nincs: 'nothing'
		},
		conditionOfProperty: {
			bontando: 'uninhabitable',
			felujitando: 'toRenew',
			atlagos: 'average',
			jo: 'good',
			felujitott: 'excellent',
			'uj-epitesu': 'newlyBuilt'
		},
		floorsInBuilding: {
			'-4': 'underground4',
			'-3': 'underground3',
			'-2': 'underground2',
			'-1': 'underground1',
			alagsor: 'basement',
			szuteren: 'suteren',
			felszuteren: 'halfSuteren',
			foldszint: 'downstairs',
			magasfoldszint: 'highDownstairs',
			felemelet: 'halfUpstairs',
			'1': '1',
			'2': '2',
			'3': '3',
			'4': '4',
			'5': '5',
			'6': '6',
			'7': '7',
			'8': '8',
			'9': '9',
			'10': '10',
			'10+': '10+'
		},
		innerHeight: {
			heightLow: 'alacsony',
			heightNormal: 'normal',
			heightExtra: 'extra',
			heightLoft: 'loft'
		},
		elevator: {
			key: 'van',
			caller: 'van',
			service: 'van',
			none: 'nincs'
		},
		comfortLevel: {
			'dupla-komfort': 'doubleComfort',
			osszkomfort: 'fullComfort',
			egyeb: 'other'
		},
		miscellaneous: {
			pool: 'medence',
			withGardenAccess: 'kertkapcsolat',
			topFloor: 'tetoteri'
		},
		parkingOption: {
			'nyilt-kocsibeallo': 'garageTitle'
		},
		'rooms.type': {
			balcony: 'erkely',
			terrace: 'terasz-tetoterasz',
			roofTerrace: 'terasz-tetoterasz',
			loggia: 'loggia',
			frenchBalcony: 'francia-erkely'
		},
		view: {
			utcai: 'street',
			udvari: 'yard',
			'kertre-nezo': 'garden',
			panorama: 'panorama'
		},
		staircaseType: {
			zart: 'closed',
			korholyoso: 'circularCorridor',
			egyeb: 'other'
		},
		livingRoomOrientation: {
			eszak: 'north',
			kelet: 'east',
			del: 'south',
			nyugat: 'west'
		}
	}
};
